import React, { useState } from 'react'
import { appInsights } from 'config/appInsights'
import { useTranslation } from 'react-i18next'
import { useMsal } from '@azure/msal-react'
import Menu from '@mui/material/Menu'
// import { useTheme } from 'contexts/ThemeProvider'
// import { useThemeV4 } from 'contexts/ThemeProviderV4'
import {
  HeaderMenuBox,
  InfoUsuarioBox,
  ItemMenu,
  MenuAvatar,
  DividerMenu
} from './MenuConta.styles'
import { Typography } from '@material-ui/core'
import { Box, ListItemIcon } from '@mui/material'
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
// import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined'
// import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined'
import MenuContaManager from './MenuContaManager'
import { Eventos } from 'utils/appInsightsConstants'
import { MenuContaProps } from './types'

export function MenuConta({
  anchorEl,
  menuContaEstaAberto,
  fecharMenuMinhaConta,
  iniciaisUsuario,
  emailUsuario,
  nomeUsuario
}: MenuContaProps) {
  // const { toggleTheme, themeName } = useTheme()
  // const { toggleThemeV4 } = useThemeV4()

  const { instance } = useMsal()

  const { t, i18n } = useTranslation('translation', {
    keyPrefix: 'componentes.menu_conta'
  })
  const [idiomaAtual, setIdiomaAtual] = useState(i18n.language)

  // const alterarTema = async () => {
  //   const usuario = {
  //     tema: themeName === 'dark' ? 'L' : 'D'
  //   }
  //   toggleTheme()
  //   toggleThemeV4()
  //   await MenuContaManager.atualizarPreferenciasUsuario(usuario)
  //   appInsights.trackEvent({
  //     name: Eventos.MENU_CONTA_ALTERAR_TEMA,
  //     properties: {
  //       tema: usuario.tema
  //     }
  //   })
  // }

  const handleChangeIdioma = async (idioma: string) => {
    const usuario = {
      idioma
    }
    setIdiomaAtual(idioma)
    i18n.changeLanguage(idioma)
    await MenuContaManager.atualizarPreferenciasUsuario(usuario)
    appInsights.trackEvent({
      name: Eventos.MENU_CONTA_ALTERAR_IDIOMA,
      properties: {
        idioma: idioma
      }
    })
  }

  return (
    <Menu
      id="menu-conta"
      data-testid="menu-conta"
      anchorEl={anchorEl}
      open={menuContaEstaAberto}
      onClose={fecharMenuMinhaConta}
      MenuListProps={{
        'aria-labelledby': 'menu-conta-button',
        sx: {
          paddingTop: 0,
          paddingBottom: 0,
          minWidth: 250
        }
      }}
      PaperProps={{
        sx: {
          bgcolor: 'background.primary'
        }
      }}
    >
      <HeaderMenuBox data-testid="header-menu">
        <MenuAvatar>{iniciaisUsuario}</MenuAvatar>
        <InfoUsuarioBox>
          <Typography variant="body1">
            {t('ola')}, {nomeUsuario}!
          </Typography>
          <Typography variant="caption">{emailUsuario}</Typography>
        </InfoUsuarioBox>
      </HeaderMenuBox>
      <DividerMenu />
      <Box>
        <ItemMenu
          onClick={() => handleChangeIdioma('pt')}
          data-testid="item-idioma-pt"
        >
          <ListItemIcon>
            {idiomaAtual === 'pt' && <CheckOutlinedIcon data-testid="check" />}
          </ListItemIcon>
          <Typography variant="h4">Português - BR</Typography>
        </ItemMenu>
        <ItemMenu
          onClick={() => handleChangeIdioma('en')}
          data-testid="item-idioma-en"
        >
          <ListItemIcon>
            {idiomaAtual === 'en' && <CheckOutlinedIcon data-testid="check" />}
          </ListItemIcon>
          <Typography variant="h4">English - EN</Typography>
        </ItemMenu>
      </Box>
      <DividerMenu />
      {/* <Box>
        <ItemMenu onClick={alterarTema} data-testid="alterar-tema">
          <ListItemIcon>
            {themeName === 'dark' ? (
              <LightModeOutlinedIcon data-testid="icone-tema-claro" />
            ) : (
              <DarkModeOutlinedIcon data-testid="icone-tema-escuro" />
            )}
          </ListItemIcon>
          {themeName === 'dark' ? (
            <Typography variant="h4" data-testid="tema-label">
              {t('tema_claro')}
            </Typography>
          ) : (
            <Typography variant="h4" data-testid="tema-label">
              {t('tema_escuro')}
            </Typography>
          )}
        </ItemMenu>
      </Box> */}
      <DividerMenu />
      <ItemMenu onClick={() => instance.logout()} data-testid="btn-sair">
        <ListItemIcon>
          <LogoutOutlinedIcon />
        </ListItemIcon>
        <Typography variant="h4">{t('sair')}</Typography>
      </ItemMenu>
    </Menu>
  )
}
